export { ModalHeader } from './ModalHeader';
export type { ModalHeaderProps } from './ModalHeader';
